webpackJsonp([246327643246349],{

/***/ 1356:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---ignite-session-16-may-2026-a0e39f21c11f6a62c5ab.js